import { Injectable } from '@angular/core';

import { Docorga } from '@docorga-v1/docorga-common';

@Injectable()
export class PatientFolderService extends Docorga.services.PatientFolderService {
  constructor() {
    super();
  }
}
